import { Form } from "antd";
import GlobalContext from "./GlobalContext";
import { useEffect, useState } from "react";
import {
  useAllDelegationList,
  useFormesJuridiquesList,
  useGovermentList,
  useNationlaityList,
  useSectorList,
} from "./FetchLists";
import { useSessionStorageState } from "ahooks";
import PropTypes from "prop-types";
import { getNbrTaches } from "../api/geoprod";

const AppContext = (props) => {
  const [globalData, setGlobalData] = useState(
    sessionStorage.getItem("globalData")
      ? JSON.parse(sessionStorage.getItem("globalData"))
      : {}
  );

  const [currentStep, setCurrentStep] = useState(
    Number(sessionStorage.getItem("currentStep")) || 0
  );

  const [transformedDataStages, setTransformedDataStages] = useState([]);
  const [openModalAccepter, setOpenModalAccepter] = useState("");
  const [dateFinSessionFormation, setDateFinSessionFormation] = useState(null);
  const [isRtl, setIsRtl] = useState(localStorage.getItem("language") === "ar");
  const [form] = Form.useForm();
  const [porteDoc, setPorteDoc] = useState([]);
  const [pageN, setPageN] = useState();
  const [brouillon, setBrouillon] = useState([]);
  const [nbrBrouillon, setNbrBrouillon] = useState("");
  const [personneMorale, setPersonneMorale] = useState(
    sessionStorage.getItem("personneMorale") === "true"
  );

  const [conflictingPlages, setConflictingPlages] = useState({});
  const [currentConflictKey, setCurrentConflictKey] = useState(null);
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [orderedConflicts, setOrderedConflicts] = useState({});

  const [listTasks, setListTasks] = useState([]);
  const [employeurByPatNumPatCL, setEmployeurByPatNumPatCL] =
    useSessionStorageState("employeurByPatNumPatCLData", { defaultValue: [] });
  const [ficheEntrepriseDGI, setFicheEntrepriseDGI] = useSessionStorageState(
    "ficheEntrepriseDGIData",
    { defaultValue: [] }
  );
  const [etablissementSecondaireDGI, setEtablissementSecondaireDGI] =
    useSessionStorageState("etablissementSecondaireDGIData", {
      defaultValue: [],
    });
  const [listActiviteRNE, setListActiviteRNE] = useSessionStorageState(
    "listActiviteRNEData",
    { defaultValue: [] }
  );
  const [entrepriseRegistrationId, setEntrepriseRegistrationId] =
    useSessionStorageState("entrepriseRegistrationIdData", {
      defaultValue: [],
    });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [matriculeFiscale, setMatriculeFiscale] = useState(
    sessionStorage?.getItem("matriculeFiscale")
  );
  const [numeroEnregistrement, setNumeroEnregistrement] = useState(
    sessionStorage?.getItem("numeroEnregistrement")
      ? sessionStorage?.getItem("numeroEnregistrement")
      : ""
  );

  const [dates, setDates] = useState(
    JSON.parse(sessionStorage.getItem("globalData"))?.dates || {
      examen: { startDate: null, endDate: null },
      rattrapage: { startDate: null, endDate: null },
    }
  );

  const [modulesExamens, setModulesExamens] = useState(
    JSON.parse(sessionStorage.getItem("globalData"))?.modulesExamens || []
  );

  const [modulesRattrapages, setModulesRattrapages] = useState(
    JSON.parse(sessionStorage.getItem("globalData"))?.modulesRattrapages || []
  );

  const gouvernoratList = useGovermentList()?.map((res) => {
    return {
      text: res?.name,
      value: res?.value,
      id: res?.id,
      name_fr: res?.name_fr,
    };
  });

  const listAllDelegations = useAllDelegationList()?.map((res) => {
    return {
      text: res?.name,
      value: res?.value,
      id: res?.id,
    };
  });

  const nationalityList = useNationlaityList()?.map((res) => {
    return {
      text: res?.name,
      value: res?.value,
    };
  });

  const FormesJuridiquesList = useFormesJuridiquesList()?.map((res) => {
    return {
      text: res?.name,
      value: res?.value,
    };
  });

  const secteurData = useSectorList()?.map((res) => {
    return {
      text: res?.name,
      value: res?.value,
      id: res?.id,
    };
  });

  const nationalityOptions = nationalityList?.map((item) => ({
    label: item?.text,
    value: item?.value,
  }));

  const gouvernoratOptions = gouvernoratList?.map((item) => ({
    label: item?.text,
    value: item?.value,
    id: item?.id,
  }));

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("-x-token-user"))?.Acces_Token) {
      fetchNbrTaches();
    }
  }, []);

  const fetchNbrTaches = async () => {
    const response = await getNbrTaches();
    setListTasks(response?.data?.nombre_taches);
    setNbrBrouillon(response?.data?.nombre_brouillon);
  };

  return (
    <GlobalContext.Provider
      value={{
        globalData,
        setGlobalData,
        form,
        isRtl,
        setIsRtl,
        porteDoc,
        setPorteDoc,
        pageN,
        setPageN,
        brouillon,
        setBrouillon,
        nationalityOptions,
        gouvernoratOptions,
        secteurData,
        gouvernoratList,
        nationalityList,
        FormesJuridiquesList,
        personneMorale,
        setPersonneMorale,
        matriculeFiscale,
        setMatriculeFiscale,
        numeroEnregistrement,
        setNumeroEnregistrement,
        listAllDelegations,
        employeurByPatNumPatCL,
        setEmployeurByPatNumPatCL,
        ficheEntrepriseDGI,
        setFicheEntrepriseDGI,
        etablissementSecondaireDGI,
        setEtablissementSecondaireDGI,
        listActiviteRNE,
        setListActiviteRNE,
        entrepriseRegistrationId,
        setEntrepriseRegistrationId,
        listTasks,
        setListTasks,
        nbrBrouillon,
        setNbrBrouillon,
        fetchNbrTaches,
        openModalAccepter,
        setOpenModalAccepter,
        conflictingPlages,
        setConflictingPlages,
        currentConflictKey,
        setCurrentConflictKey,
        showConflictModal,
        setShowConflictModal,
        orderedConflicts,
        setOrderedConflicts,
        dateFinSessionFormation,
        setDateFinSessionFormation,
        currentStep,
        setCurrentStep,
        transformedDataStages,
        setTransformedDataStages,
        dates,
        setDates,
        modulesExamens,
        setModulesExamens,
        modulesRattrapages,
        setModulesRattrapages,
        pagination, setPagination

      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};

AppContext.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppContext;
